module.exports = __webpack_public_path__ + "img/default.e438c1c7.svg";